import { debounce } from '../../core/helpers';
import { removeMarketingBlocks } from './actions';

const resizeMarketingBlocks = () => {
  const marketingBlocks = document.querySelectorAll('[data-collection-marketing-block]');
  const productTiles = document.querySelectorAll('.collection-grid-section [data-product-tile]');
  if (!marketingBlocks.length || !productTiles.length) {
    return;
  }

  const firstTileImage = productTiles[0].querySelector('[data-product-tile-image]');
  const image_height = firstTileImage ? firstTileImage.offsetHeight : 0;

  if (image_height > 0) {
    const mainBlocks = document.querySelectorAll('[data-collection-marketing-block].plp-mb--main');
    const mainBlockFormatFull = Array.from(mainBlocks).some(block => block.dataset.format === 'full');

    if (mainBlockFormatFull) {
      document.querySelectorAll('[data-collection-marketing-block].plp-mb--main.hidden--mobile').forEach(block => {
        block.style.minHeight = `${image_height / 2}px`;
      });
      document.querySelectorAll('[data-collection-marketing-block].plp-mb--main.hidden--desktop').forEach(block => {
        block.style.height = `${image_height}px`;
      });
    } else {
      mainBlocks.forEach(block => {
        block.style.height = `${image_height}px`;
      });
    }

    document.querySelectorAll('[data-collection-marketing-block].plp-mb--extra').forEach(block => {
      block.style.height = `${image_height}px`;
    });
  }
};

const initMarketingBlock = () => {
  // Delete the marketing blocks created in liquid if not needed
  removeMarketingBlocks();

  $(document).on('click', '[data-collection-marketing-block]', (e) => {
    const $item = $(e.currentTarget);

    if (typeof $item.data('url') === 'undefined' || !$item.data('url').length) {
      return;
    }

    window.location.href = $item.data('url');
  });

  // [ADA]
  $(document).on('keypress', '[data-collection-marketing-block]', (e) => {
    const key = e.which;
  
    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      if (typeof $item.data('url') !== 'undefined' && $item.data('url').length) {
        window.location.href = $item.data('url');
      }
    }
  });

  /*document.addEventListener('astr-plp-layout-changed', (e) => {
    console.log('astr-plp-layout-changed', e.data);

    $('[data-format="tile"]').removeClass('column-sm-2').removeClass('column-sm-3').removeClass('column-sm-4').removeClass('column-sm-5').removeClass('column-sm-6');
    $('[data-format="half"]').removeClass('column-sm-2').removeClass('column-sm-3').removeClass('column-sm-4').removeClass('column-sm-5').removeClass('column-sm-6');
    $('[data-format="full"]').removeClass('column-sm-15');

    if (e.data.items_per_rows === 2) {
      $('[data-format="tile"]').addClass('column-sm-6');
      $('[data-format="half"]').addClass('column-sm-6');
    }

    if (e.data.items_per_rows === 3) {
      $('[data-format="tile"]').addClass('column-sm-4');
      $('[data-format="half"]').addClass('column-sm-4');
    }

    if (e.data.items_per_rows === 4) {
      $('[data-format="tile"]').addClass('column-sm-3');
      $('[data-format="half"]').addClass('column-sm-6');
    }

    // We're using a 15 grid layout
    if (e.data.items_per_rows === 5) {
      $('[data-format="tile"]').addClass('column-sm-3');
      $('[data-format="half"]').addClass('column-sm-6');
      $('[data-format="full"]').addClass('column-sm-15');
    }

    window.setTimeout(() => {
      $(window).trigger('resize');
      $(window).trigger('scroll');
    }, 200);
  });*/

  window.addEventListener('resize', debounce(() => {
    resizeMarketingBlocks();
  }, 10));
};

export {
  initMarketingBlock,
  resizeMarketingBlocks,
};
